import React from 'react'

export type TagIconProps = {
  size?: number
}

export const OutstandingIcon = ({ size = 16 }: TagIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M2.46094 10.3077C2.46094 6.95433 7.19705 4.35817 6.1276 0.5C8.64844 0.5 13.4609 3.96154 13.4609 10.3077C13.4609 11.6848 12.8815 13.0055 11.85 13.9792C10.8186 14.953 9.41963 15.5 7.96094 15.5C6.50225 15.5 5.1033 14.953 4.07185 13.9792C3.0404 13.0055 2.46094 11.6848 2.46094 10.3077Z"
        fill="url(#paint0_linear_19808_227442)"
      />
      <path
        d="M10.4054 12.0385C10.4054 14.1194 9.18316 14.9231 7.96094 14.9231C6.73872 14.9231 5.51649 14.1194 5.51649 12.0385C5.51649 9.95757 7.04427 8.9375 6.73872 7.42308C8.34288 7.42308 10.4054 9.95757 10.4054 12.0385Z"
        fill="#FAC458"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19808_227442"
          x1="7.96094"
          y1="0.5"
          x2="7.96094"
          y2="15.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCC14D" />
          <stop offset="0.296875" stopColor="#FB8847" />
          <stop offset="0.885417" stopColor="#FD4A49" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const BlackFridayIcon = ({ size = 16 }: TagIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.589736 6.9507L7.13323 12.4796C7.47489 12.7663 7.89528 12.8985 8.32012 12.8614C8.74497 12.8243 9.13713 12.6237 9.42531 12.2821L12.8731 8.1881C13.448 7.50627 13.3588 6.47089 12.677 5.89602L6.11717 0.387894C5.77551 0.101198 5.35512 -0.031009 4.93028 0.00612774L4.78173 0.019497L1.35178 0.630025C0.580824 0.751834 0.0237653 1.43218 0.016338 2.21502L0 5.71628C0.00297094 6.18123 0.209456 6.64766 0.589736 6.9507ZM0.742735 5.68954L0.76056 2.20611C0.76056 1.77829 1.06508 1.41732 1.48696 1.34305L4.91691 0.732523L4.99119 0.726581C5.23183 0.705784 5.46059 0.780058 5.64181 0.931576L12.2031 6.45901C12.3844 6.61053 12.4958 6.82444 12.5151 7.06508C12.5359 7.30573 12.4616 7.53449 12.3101 7.71572L8.86232 11.8097C8.7108 11.9909 8.49689 12.1023 8.25625 12.1216C8.0156 12.1424 7.78684 12.0681 7.60561 11.9166L1.06211 6.38771C0.861576 6.21836 0.74719 5.96732 0.741248 5.68954H0.742735ZM1.78405 3.7198C1.85387 4.53384 2.57581 5.1414 3.38984 5.07158C4.20388 5.00176 4.81144 4.27983 4.74162 3.46579C4.6718 2.65175 3.94986 2.04419 3.13583 2.11401C2.32179 2.18383 1.71423 2.90577 1.78405 3.7198ZM2.52381 3.65593C2.48965 3.24891 2.79269 2.88794 3.19971 2.85377C3.60673 2.81961 3.96769 3.12264 4.00186 3.52966C4.03602 3.93668 3.73299 4.29765 3.32597 4.33182C2.91895 4.36598 2.55798 4.06295 2.52381 3.65593Z"
        fill="url(#paint0_radial_19808_227447)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_19808_227447"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.44616 -1.79814) rotate(175.11) scale(20.0241 20.0241)"
        >
          <stop stopColor="#EC74F8" />
          <stop offset="1" stopColor="#3E87F7" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export const CyberIcon = ({ size = 16 }: TagIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 17" fill="none">
      <path
        d="M5.6582 4.67215V4.30227C5.6582 3.09022 6.65402 2.1001 7.86607 2.1001C9.07812 2.1001 10.0739 3.09591 10.0739 4.30796V4.63232"
        stroke="white"
        strokeWidth="0.620706"
        strokeMiterlimit="10"
      />
      <path d="M12.2422 4.46167H3.47335L3.21729 14.6076H12.4983L12.2422 4.46167Z" fill="white" />
      <path
        d="M10.0798 6.48755V7.02813C10.0798 8.24018 9.08398 9.236 7.87193 9.236C6.65988 9.236 5.66406 8.24018 5.66406 7.02813V6.48755"
        stroke="#225EEF"
        strokeWidth="0.68478"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.00391 6.35679C5.00391 5.99829 5.29981 5.70239 5.6583 5.70239C6.01679 5.70239 6.31269 5.99829 6.31269 6.35679"
        stroke="#225EEF"
        strokeWidth="0.34239"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9.41992 6.35679C9.41992 5.99829 9.71582 5.70239 10.0743 5.70239C10.4328 5.70239 10.7287 5.99829 10.7287 6.35679"
        stroke="#225EEF"
        strokeWidth="0.34239"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M12.5153 15.3875L12.4983 14.6079H3.21727L3.2002 15.3875H12.5153Z" fill="#FF1D38" />
    </svg>
  )
}

export const NewIcon = ({ size = 16 }: TagIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 17" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9998 12.4666L3.68938 15.0994L4.86132 10.1863L1.02539 6.90046L6.06011 6.49683L7.9998 1.83325L9.9395 6.49683L14.9742 6.90046L11.1383 10.1863L12.3102 15.0994L7.9998 12.4666Z"
        fill="#F0B63F"
      />
    </svg>
  )
}

export const TopSellingIcon = ({ size = 16 }: TagIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 12 13" fill="none">
      <g clipPath="url(#clip0_15232_29007)">
        <path d="M6.58333 0.875L0.75 7.625H6L5.41667 12.125L11.25 5.375H6L6.58333 0.875Z" fill="#F0B63F" />
      </g>
      <defs>
        <clipPath id="clip0_15232_29007">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
